const IS_SERVER_SIDE = false;

const ServerSideService = {
  isServerSide: IS_SERVER_SIDE,
};

export default ServerSideService;
